module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_oslo_viken_neg.eb5e7c84.png";